import script from "./AppSource.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSource.vue?vue&type=script&setup=true&lang=ts"

import "./AppSource.vue?vue&type=style&index=0&id=1d0bb622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0bb622"]])

export default __exports__